import { A365BackendModel } from '../../model/a365.backendmodel';

export function isSyMsCDMDb(dbResource: A365BackendModel.DatabaseResource): boolean {
    let flag: boolean = false;
    if (!dbResource || !dbResource.properties) {
        return flag;
    }
    const content = dbResource.properties;
    if (content.Properties) {
        // value returned from backend
        flag = content.Properties.DerivedModelDBInfo != null || content.Properties.IsSyMSCDMDatabase === true || content.Properties.IsSyMSCDMDatabase === 'true';
    } else if (content.properties) {
        // value generated in A365 when new a database
        flag = content.properties.derivedModelDBInfo != null || content.properties.isSyMSCDMDatabase;
    }
    return flag;
}
